import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/terms/page.tsx");
